// src/stone/icons/StoreShop.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StoreShop = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M6.667 17.333a1 1 0 0 1 1 1v17.334h24.666V18.333a1 1 0 1 1 2 0v18.334a1 1 0 0 1-1 1H6.667a1 1 0 0 1-1-1V18.333a1 1 0 0 1 1-1" }),
      /* @__PURE__ */ jsx("path", { d: "M5.809 2.819a1 1 0 0 1 .858-.486h26.666a1 1 0 0 1 .858.486l5 8.333a1 1 0 0 1 .142.512 5.987 5.987 0 0 1-10.442 4.012A5.96 5.96 0 0 1 20 15.68a5.962 5.962 0 0 1-8.891-.003A5.988 5.988 0 0 1 .667 11.664a1 1 0 0 1 .142-.512zm1.424 1.514L2.675 11.93a3.987 3.987 0 0 0 7.542 1.534 1 1 0 0 1 1.79.003 3.962 3.962 0 0 0 7.097 0 1 1 0 0 1 1.791 0 3.962 3.962 0 0 0 7.098 0 1 1 0 0 1 1.79-.003 3.987 3.987 0 0 0 7.542-1.534l-4.558-7.597zM15.667 26.667a1 1 0 0 1 1-1h6.666a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-9h-4.666v9a1 1 0 1 1-2 0z" })
    ]
  }
);
var StoreShop_default = StoreShop;

export {
  StoreShop_default
};
